import axios, { AxiosError } from 'axios';

import { AXIOS_INTERCEPTOR_EVENT_NAME } from 'common/constants';

axios.interceptors.response.use(
  (response) => response,
  (err: AxiosError) => {
    try {
      const axiosInterceptorCustomEvent = new CustomEvent(AXIOS_INTERCEPTOR_EVENT_NAME, { detail: err });
      window.dispatchEvent(axiosInterceptorCustomEvent);
    } catch (e) {
      console.log(e);
    }

    return Promise.reject(err);
  },
);
